import useAPI from '../../hooks/useAPI';
import { GetNotificationsByUserResponse } from '../../types/backendResponses/GetNotificationsByUserResponse';
import { buildApiUrl } from '../config';

export const getUserPushNotificationsResponse = () => {
  const { callAPI, ...state } = useAPI<GetNotificationsByUserResponse>();

  const getPushNotificationsResponse = async (): Promise<void> => {
    await callAPI(buildApiUrl(`pushNotifications`));
  };

  return { getPushNotificationsResponse, ...state };
};
